import Vue from "vue";
import VueRouter from "vue-router";
import { isMobile } from "@/utils/utils";
import store from "../store/index";
import { routes } from "./routes";

Vue.use(VueRouter);

const addTrackPvLog = (to) => {
  setTimeout(() => {
    try {
      const userInfo = localStorage.getItem("userInfo") ? JSON.parse(localStorage.getItem("userInfo")) : {};
      console.log("userInfo---->", userInfo);
      const { id = "", name = "" } = userInfo;
      if (window.track) {
        if (id && name) {
          window.track.setUserId(`${id}|${name}`);
        }
        window.track._pvTrack(to.meta?.title || to.query?.title || document.title);
      }
    } catch (error) {
      console.error(error);
    }
  });
};

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

let isInit = false;

const mobileRedirectFn = (to) => {
  const mobileDomain = process.env.VUE_APP_MOBILE_DOMAIN;
  const { mobilePath = "/", mobileQueryMap = {} } = to.meta || {};

  // 1. 原始 query 透传
  const finalQuery = { ...to.query };
  // 2. params → query 映射
  Object.keys(mobileQueryMap).forEach((paramKey) => {
    const queryKey = mobileQueryMap[paramKey];
    const value = to.params?.[paramKey];
    if (value !== undefined) {
      finalQuery[queryKey] = value;
    }
  });
  // 3. 拼接 URL
  const queryParams = new URLSearchParams(finalQuery).toString();
  const redirectUrl = `${mobileDomain}${mobilePath}${queryParams ? `?${queryParams}` : ""}`;

  // 开发环境特殊处理：添加额外调试信息
  if (process.env.NODE_ENV === "development") {
    console.log("【开发环境】H5 重定向地址:", redirectUrl);
    console.log("【开发环境】原始路由参数:", { query: to.query, params: to.params });
    window.location.href = redirectUrl;
  } else {
    console.log("【生产环境】H5 重定向地址:", redirectUrl);
    window.location.href = redirectUrl;
  }

  return;
};

router.beforeEach((to, from, next) => {
  if (!isInit && document.referrer.indexOf("google") !== -1) {
    isInit = true;
    next({
      path: "/",
    });
    return;
  }
  console.log("beforeEach to--->", to);

  if (isMobile()) {
    return mobileRedirectFn(to);
  }

  next();
});

router.afterEach((to) => {
  console.log("afterEach----->", to.fullPath);
  addTrackPvLog(to);
  store.commit("base/SET_REDIRECT_PATH", to.fullPath);
  // const pushTrack = initNuxtTrack("official-br");
  // pushTrack({
  //   pageTitle: to.meta.title || "未配置页面title",
  //   moduleName: "巴西官网",
  //   routeName: to.path,
  // });
});

export default router;
